import { RoleListDto } from '@asset-metrix/portal-gateway-client-js';
import { QueryFunction, useSuspenseQuery } from '@tanstack/react-query';

import { HttpError } from '../../utils/errors';
import { portalGatewayClient } from '../portalGatewayClient';

const fetchUserRoles: QueryFunction<RoleListDto> = async () => {
  const res = await portalGatewayClient.auth.getUserRoles({
    offset: 0,
    limit: 1000,
  });
  if (res.ok) {
    return res.data.data;
  }

  throw new HttpError('Error fetching user roles', res.status);
};

export function useUserRolesData() {
  return useSuspenseQuery({
    queryKey: ['userRoles'],
    queryFn: fetchUserRoles,
    gcTime: Infinity,
  });
}
